<script lang="ts" setup>
import { RECHARGE_TYPE_NAME } from '@/utils/enum'

defineProps<{
  config: any
  records: any[]
  fetching: boolean
  ending: boolean
  page: number
  setInfiniteRef: (el: HTMLElement | null) => void
}>()

/** 订阅类记录（标题展示为 "Vip (1 week)" 形态），沿用 default 版的数字枚举写法 */
const SUBSCRIPTION_TYPES: number[] = [
  RECHARGE_TYPE_NAME.SubscriptionDiscount,
  RECHARGE_TYPE_NAME.Subscription,
]
</script>

<template>
  <div :ref="setInfiniteRef" class="nm-page h-100dvh overflow-scroll bg-n-bg-global">
    <BasicNavbar class="nm-navbar color-n-text-1">
      <p class="nm-navbar-title">
        {{ config.texts.pageTitle }}
      </p>
    </BasicNavbar>

    <div v-if="!fetching && page === 1 && records.length === 0" class="mt-52px pt-15vh w-full text-center flex flex-col justify-center">
      <BizBlockEmpty :title="config.texts.noRecord" />
    </div>

    <div v-else class="nm-body">
      <div class="nm-card">
        <div v-for="item in records" :key="item.orderId" class="nm-row">
          <div class="nm-row-main min-w-0">
            <h3 v-if="SUBSCRIPTION_TYPES.includes(item.rechargeType)" class="nm-title line-clamp-1">
              {{ `${item.rechargeType === RECHARGE_TYPE_NAME.SubscriptionDiscount ? config.texts.discountedVip : config.texts.unlimitedVip} (${item.cycle})` }}
            </h3>
            <h3 v-else class="nm-title line-clamp-1">
              {{ item.coins }} {{ config.texts.coins }}
            </h3>
            <p class="nm-date">
              {{ $d(new Date(item.rechargeTime), 'short') }}
            </p>
          </div>

          <div class="nm-row-aside text-right">
            <p class="nm-type">
              {{ config.texts.rechargeTypeLabel(item.rechargeType) }}
            </p>
            <p v-if="item.expireTime" class="nm-expire">
              {{ config.texts.expireOn }} {{ $d(new Date(item.expireTime), 'short') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="ending && records.length" class="nm-foot">
      {{ config.texts.noMore }}
    </div>
    <div v-else-if="fetching" class="nm-foot flex items-center justify-center">
      <div class="animate-spin">
        <i-icon-park-outline-loading />
      </div>
    </div>
  </div>
</template>

<style scoped>
.nm-page {
  --nm-ink-1: #2B1B34;
  --nm-ink-2: #71607E;
  --nm-ink-3: #AB9BB8;
  --nm-purple: #7C4DE8;
  --nm-line: #F2EAF4;
  --nm-font-display: 'Baloo 2', 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --nm-font-text: 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-family: var(--nm-font-text);
}

/* 顶栏：back + 常驻标题。BasicNavbar 根节点会带上本组件的 scope 属性，故可直接命中 */
.nm-navbar {
  background: #FBF6FB;
  height: 52px;
}

.nm-navbar-title {
  margin-left: 2px;
  font-family: var(--nm-font-display);
  font-size: 19px;
  font-weight: 700;
  color: var(--nm-ink-1);
  line-height: 1.2;
}

.nm-body {
  padding: 60px 16px 24px;
}

/* 白卡：r20 + padding 6/16 + 紫调投影 */
.nm-card {
  background: #FFFFFF;
  border-radius: 20px;
  padding: 6px 16px;
  box-shadow: 0 4px 16px rgba(124, 77, 232, 0.08);
}

.nm-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid var(--nm-line);
}

.nm-row:last-child {
  border-bottom: none;
}

.nm-row-aside {
  padding-left: 12px;
  flex-shrink: 0;
}

.nm-title {
  font-size: 14px;
  font-weight: 800;
  color: var(--nm-ink-1);
  line-height: 1.3;
}

.nm-date {
  margin-top: 5px;
  font-size: 12px;
  color: var(--nm-ink-3);
  line-height: 1.2;
}

.nm-type {
  font-size: 13px;
  font-weight: 700;
  color: var(--nm-purple);
  line-height: 1.3;
}

.nm-expire {
  margin-top: 5px;
  font-size: 11px;
  color: var(--nm-ink-3);
  line-height: 1.2;
}

.nm-foot {
  padding: 16px 0 28px;
  text-align: center;
  font-size: 13px;
  color: var(--nm-ink-3);
}
</style>
